<div class="block__left-side-panel">
    <h1 class="text-items__title">{{'PERSONALIZE_TRAVEL_CARD_SIDE_TITLE' | translate}}</h1>
    <p class="text-items__description"><span>{{'PERSONALIZE_TRAVEL_CARD_SIDE_DESCRIPTION' | translate}}</span></p>
</div>
